import React, { Component } from 'react';
import styles from './styles';
import { css } from 'aphrodite';
import { ReactComponent as Check } from '../../../../assets/images/check.svg';

class PackagingButton extends Component {

    render() {
        const { onSelectPackage, isOpened, isSelected, data, openProductsList } = this.props;

        return(
            <div className={css(styles.packagingButton)}>
                <div className={css(styles.packagingButtonInner, isSelected ? styles.selected : isOpened ? styles.openedButton : '')} onClick={(e) => {onSelectPackage(); openProductsList(e)}}>
                    <span className={css(styles.span)}>{data.name} {data.fieldMetricImperial.toLowerCase() === "metric" ? "ml" : "oz"}</span>
                    { isSelected && <Check className={css(styles.check)} />}
                </div>
            </div>
        );
    }

}

export default PackagingButton;
